import { InjectionToken } from '@angular/core';
import type { ToastVariant } from './toast.types';

export interface ToastConfig {
  /** Default auto-dismiss delay (ms). `0` = sticky. */
  durationMs?: number;
  /** Max visible toasts at once (oldest dismissed first). */
  maxVisible?: number;
  /** Overlay z-index (below tour, above dialogs). */
  zIndex?: number;
  /** Per-variant duration overrides. */
  durationByVariant?: Partial<Record<ToastVariant, number>>;
}

export const TOAST_CONFIG = new InjectionToken<ToastConfig>('TOAST_CONFIG', {
  factory: () => ({
    durationMs: 4000,
    maxVisible: 5,
    zIndex: 10050,
    durationByVariant: {
      success: 3500,
      info: 4000,
      warning: 5000,
      error: 6000,
    },
  }),
});
